module.exports = __webpack_public_path__ + "img/k_live.99130251.jpg";